import {addiesaasReady, addiesaasBeforeReady} from 'utils/vue/lib/utils'
import {beforeListeners, listeners} from './listeners'

addiesaasBeforeReady(beforeListeners)
addiesaasReady(listeners)
